import ButtonNav from "components/ButtonNav"
import React from "react"
import { useDispatch } from "react-redux"
import { hotelAction } from "redux/hotel/slice/user"

function CustomNavBar(props) {
  const dispatch = useDispatch()

  function handleButtonNav(item) {
    dispatch(hotelAction.setHotelCategoryLink(item))
  }

  return (
    <>
      {props.navBarList?.map((item, i) => {
        return (
          <ButtonNav
            style={{ marginRight: 12, marginTop: 12 }}
            onPress={() => handleButtonNav(item)}
            key={i}
            isActive={props.activeTab === item.id ? true : false}>
            {item.name}
          </ButtonNav>
        )
      })}
    </>
  )
}

export default CustomNavBar
